<template>
    <div>
        <v-toolbar :dense="true" :flat="true" color="transparent">
            <v-file-input
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    label="Выберите файл"
                    v-model="files"/>
<!--            <v-btn depressed color="blue lighten-2" @click="importFiles" :disabled="files == null">
                Загрузить
            </v-btn>-->
            <button-icon-tooltip
                icon="backup"
                @click="importFiles"
                color="blue lighten-2"
                tooltip-text="Загрузить файл"
                :disabled="files == null"
            />
            <v-spacer></v-spacer>


            <button-icon-tooltip
                icon="remove_red_eye"
                @click="visibleHiddenGroups = !visibleHiddenGroups"
                :color="visibleHiddenGroups ? 'success' : ''"
                tooltip-text="Показать скрытые списки ()"
            />


        </v-toolbar>
        <div class="pl-4" v-show="lastFile.fileName !== ''">
            Последний загруженный файл: {{lastFile.fileName}}<br>
            Процент выполнения: {{lastFile.percent}}%
            <v-btn
                    text
                    color="primary"
                    @click="getLastJob"
            >Обновить</v-btn>
            <br>
            <div v-show="lastFile.error">Есть ошибки при загрузке</div>
        </div>

        <v-container ma-0 pa-0 px-4 fluid>
            <catalog-table/>
        </v-container>
        <v-snackbar
                v-model="paramsSnackbar.show"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'
import CatalogTable from '@components/bot/offer/CatalogTable'
import ButtonIconTooltip from '@components/ui/buttons/ButtonIconTooltip'

export default {
    name: 'Index',
    components: {
        CatalogTable,
        ButtonIconTooltip
    },
    data() {
        return {
            paramsSnackbar: {
                color: 'success',
                text: 'Операция прошла успешно!',
                show: false
            },
            snackbar: false,
            dialog: false,
            dialogParams: {},
            visibleHiddenGroups: false,
            windowHeight: 0,
            files: null,
            lastFile: {
                percent: 0,
                fileName: '',
                error: false
            }
        }
    },
    watch: {
        dialog() {
            if (this.dialog === false) {
                this.editCardId = null
                this.cardListId = null
            }
        }
    },
    methods: {
        importFiles() {
            let formData = new FormData()
            formData.append('catalog', this.files)
            this.$store.dispatch('cards/importItems', { botId: this.$route.params['pathMatch'], formData: formData }).then(response => {
                if (response.ok) {
                    this.paramsSnackbar.color = 'success'
                    this.paramsSnackbar.text = 'Файл успешно сохранен'
                    this.files = null
                } else {
                    this.paramsSnackbar.color = 'error'
                    this.paramsSnackbar.text = 'Произошла ошибка при сохранении файла'
                }

                this.paramsSnackbar.show = true
            })
        },
        handleResize() {
            this.windowHeight = window.innerHeight
        },
        getLastJob() {
            this.$store.dispatch('cards/getLastJob', this.$route.params['pathMatch']).then(response => {
                if (response.ok) {
                    if (response.response.data && response.response.data.hasOwnProperty('percent')) {
                        this.lastFile.percent = response.response.data.percent
                        this.lastFile.fileName = response.response.data.params.fileName
                        this.lastFile.error = response.response.data.status === 'error'
                    }
                    this.paramsSnackbar.color = 'success'
                    this.paramsSnackbar.text = 'Данные обновлены!'
                    this.paramsSnackbar.show = true
                }
            })
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
        this.getLastJob()
        if (this.$route.query.hasOwnProperty('message')) {
            const message = this.$route.query
            switch (message) {
                case 'start':

                    break;
            }
            console.log()
        }
    },
    computed: {
        ...mapGetters({
            cards: 'cards/cards'
        }),
        allLoaded() {
            return this.cardsLoaded && this.cardListsLoaded
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active ;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
</style>
